import axios from 'axios'
export default {
  namespaced: true,
  state: () => ({
    servicetpls: []
  }),
  getters: {
    servicetpls: state => state.servicetpls,
    byId: state => id => {
      for (const val of state.servicetpls) {
        if (val.id === id) {
          return val
        }
      }
      return null
    }
  },
  mutations: {
    set (state, servicetpls) {
      state.servicetpls = servicetpls
    }
  },
  actions: {
    async init ({ commit, dispatch }) {
      try {
        const response = await axios.get('/api/static/service-templates')
        const servicetpls = response.data.data
        commit('set', servicetpls)
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    }
  }
}
